var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CBadge',_vm._g({staticClass:"tw-whitespace-normal",attrs:{"rounded":_vm.rounded,"variant":"info"}},_vm.$listeners),[_vm._v("\n  "+_vm._s(_vm.zeroInterest ? _vm.$t('interest-free installments') : _vm.$t('installments'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }